import type { LandingPageFeature } from '@/app/components/LandingPage/LandingPageFeatures/types';

const womensHealthFeatures: LandingPageFeature[] = [
  {
    id: 'cycle_insights',
    title: 'cycle_insights',
    description: 'cycle_insights_copy',
    image: {
      format: 'svg',
      localizedAlt: 'womens_features_cycle_insights_img_alt',
      localizedSrc: 'cycle_insights_app_ui_img',
    },
  },
  {
    id: 'period_prediction',
    title: 'pdp_horizon_period_prediction_title',
    description: 'period_prediction_copy',
    image: {
      format: 'svg',
      localizedAlt: 'womens_features_period_prediction_img_alt',
      localizedSrc: 'period_prediction_app_ui_img',
    },
  },
  {
    id: 'fertile_window',
    title: 'fertile_window_title',
    description: 'fertile_window_copy',
    image: {
      format: 'svg',
      localizedAlt: 'fertile_window_image_alt',
      localizedSrc: 'fertile_window_app_ui_img',
    },
  },
  {
    id: 'pregnancy_insights',
    title: 'pregnancy_insights',
    description: 'prego_insight_copy',
    image: {
      format: 'svg',
      localizedAlt: 'womens_features_pregnancy_insight_img_alt',
      localizedSrc: 'pregnancy_insights_app_ui_img',
    },
  },
];

export default womensHealthFeatures;
